import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { FormLayout, OrderDetailPage, Remark } from "@careinfo/layout";
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
import { useEffect, useState } from "react";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupRequestValidationForm } from "../../utils/validationSchemas";
import DriverForm from "../DriverForm";
import Modal from "../Reusable/Modal";
import VehicleForm from "../VehicleForm";
import CourierPickupRequestForm from "./CourierPickupRequestForm";
import DataTable from "../Reusable/DataTable";
import { useSearchParams } from "react-router-dom";
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../utils/classNames";
import moment from "moment";
import NACell from "../Reusable/DataTable/NACell";
import Suborders from "./Suborders";

const CreateCourierPickupRequest = (props: any) => {
  const {
    handleCreate,
    isLoading,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
    gridData,
  } = props;
  const [senderId, setSenderId] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        order_count: 0,
      };
    },
    resolver: yupResolver(createPickupRequestValidationForm),
  });
  const [searchParams, setSearchParms] = useSearchParams();
  const [statusData, setStatusData] = useState<any>([]);
  const [statuslist, setStatusList] = useState<any>([]);
  const [openorderhistoryPopup, setOpenOrderHistoryPopup] = useState(false);
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [rowid, setRowid] = useState();
  const [openSuborderpopup, setOpensuborderPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.default_sender?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  const checkedAllItems = searchParams.get("selectAllItems") === "1";

  const handleIndividualSelect = (value: string) => {
    const clonedParams = new URLSearchParams(searchParams);
    const selectedItems = clonedParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      clonedParams.set("selectedItems", value);
      setSearchParms(clonedParams);
      return;
    }
    const itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        clonedParams.set("selectedItems", newSelectedItems);
      } else {
        clonedParams.delete("selectedItems");
      }
      clonedParams.set("selectAllItems", "0");
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      clonedParams.set("selectedItems", newSelectedItems);
    }
    setSearchParms(clonedParams);
  };

  useEffect(() => {
    if (Array.isArray(gridData?.results)) {
      setStatusData([...gridData?.results]);
    }
  }, [gridData]);

  useEffect(() => {
    {
      statusData?.map((x: any) => {
        if (x?.name === "Initial") {
          setStatusList(x?.status_id);
        }
      });
    }
  }, [statusData]);

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const clonedParams = new URLSearchParams(searchParams);
    const isSelected = clonedParams.get("selectAllItems");
    if (isSelected === "1") {
      clonedParams.set("selectAllItems", "0");
      clonedParams.delete("selectedItems");
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      clonedParams.set("selectAllItems", "1");
      clonedParams.set("selectedItems", selectedItems);
    }
    setSearchParms(clonedParams);
  };

  let defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => {
            handleIndividualSelect(row?.original?.id);
          }}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            className={tw`cursor-pointer focus:outline-none pr-4 relative`}
            onClick={() => {
              setOpenOrderHistoryPopup(!openorderhistoryPopup);
              setSelectedOrder(row?.original?.id);
            }}
          >
            <ClientAccessControl allowedPermissions={["can_view_order_id"]}>
              <p
                className={tw`text-xs text-gray-500 text-center whitespace-nowrap`}
              >
                {row?.original?.order_number}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              children={
                <p
                  className={classNames(
                    row?.original?.is_duplicate
                      ? tw`text-red-600 text-bold `
                      : "",
                    tw`whitespace-nowrap text-center`
                  )}
                >
                  {getValue() ?? "N/A"}
                </p>
              }
              allowedPermissions={["can_view_tracking"]}
            />
            <p
              className={tw`text-xs text-gray-500 text-center whitespace-nowrap`}
            >
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>
            <ClientAccessControl
              children={
                <p className={tw`text-xs text-gray-500 uppercase text-center`}>
                  {row?.original?.service_type?.name}
                </p>
              }
              allowedPermissions={["can_view_service_type"]}
            />
            {row?.original?.is_pickup_created && (
              <span
                className={tw` absolute -top-2 text-[10px] -right-1 text-white px-[4px] bg-red-400 rounded-full `}
              >
                P
              </span>
            )}
          </button>
        );
      },
    },
    {
      header: "Ref. No.",
      accessorKey: "reference_number",
      cell: ({ getValue }: any) => {
        return (
          <ClientAccessControl
            children={<p> {getValue() || "N/A"} </p>}
            allowedPermissions={["can_view_reference"]}
          />
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.pickup_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p className={tw``}>
                  {row?.original?.sender?.full_name ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_sender_name"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap text-sm`}>
                  {row?.original?.sender?.primary_contact ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_sender_number"]}
            />
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row }: any) => {
        return (
          <div className={tw`w-full`}>
            <ClientAccessControl
              children={
                <p className={tw``}>
                  {row?.original?.receiver.full_name ?? "N/A"}
                </p>
              }
              allowedPermissions={["can_view_receiver_name"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap text-sm`}>
                  {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_receiver_number"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`text-sm w-full max-w-[200px]`}>
                  {row?.original?.receiver.address ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_receiver_location"]}
            />
          </div>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: NACell,
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap`}>
                  COD: {row?.original?.cod ?? 0.0}
                </p>
              }
              allowedPermissions={["can_view_cod"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap`}>
                  Collected: {row?.original?.collected_cod ?? 0.0}
                </p>
              }
              allowedPermissions={["can_view_collected"]}
            />
            <ClientAccessControl allowedPermissions={["can_view_d_charge"]}>
              <button
                disabled={row?.original.payment_method?.name === "CREDIT"}
                className="whitespace-nowrap cursor-pointer focus:outline-none"
              >
                {row?.original.payment_method?.name === "CREDIT"
                  ? "CREDIT"
                  : ` D. Charge:${getValue() ?? 0}`}
              </button>
            </ClientAccessControl>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p>
                  {getValue()}
                  <span className="text-gray-500 text-xs">
                    {row?.original?.package_type?.unit}
                  </span>
                </p>
              }
              allowedPermissions={["can_view_weight"]}
            />
          </>
        );
      },
    },
    {
      header: "Pieces",
      accessorKey: "piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <button
                  className={tw`cursor-pointerb focus:outline-none`}
                  onClick={() => {
                    setOpensuborderPopup(!openSuborderpopup);
                    setRowid(row?.original?.id);
                  }}
                >
                  {getValue() ?? 0.0}
                </button>
              }
              allowedPermissions={["can_view_piece"]}
            />
          </>
        );
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => (
        <>
          <ClientAccessControl
            children={
              <button
                className={tw`focus:outline-none`}
                onClick={() => {
                  setSelectedOrder(row?.original?.id);
                  setOpenReviewModal(true);
                }}
              >
                {getValue()} Remarks
              </button>
            }
            allowedPermissions={["can_view_remarks"]}
            renderNoAccess={<p>{getValue()} Remarks</p>}
          />
        </>
      ),
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <>
                  <p
                    className={tw`uppercase px-1 text-center rounded-md`}
                    style={{
                      background: row?.original?.delivery_status?.color,
                    }}
                  >
                    {getValue()}
                  </p>
                  <p className={tw`text-xs text-primary `}>
                    {row?.original?.rider?.name}
                  </p>
                </>
              }
              allowedPermissions={["can_view_status"]}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <CourierPickupRequestForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          watch={watch}
          control={control}
          setOpenAddDriverPopup={setOpenAddDriverPopup}
          setOpenAddVehiclePopup={setOpenAddVehiclePopup}
          setSenderId={setSenderId}
          isCreate={true}
        />
      </FormLayout>
      <DataTable
        queryKey={"order"}
        url={APIS.ORDER}
        columns={defaultColumns}
        tableName={"order-table"}
        params={{
          vendor: senderId,
          delivery_status__in: statuslist?.map((item) => item?.id).join(","),
          is_pickup_created: false,
        }}
      />
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openorderhistoryPopup}
        setIsOpen={setOpenOrderHistoryPopup}
        title={"Order Detail"}
      >
        <OrderDetailPage selectedOrder={selectedOrder} />
      </Modal>
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
      >
        <div className={tw`w-[600px]`}>
          <Remark selectedOrder={selectedOrder} />
        </div>
      </Modal>
      <Modal
        isOpen={openSuborderpopup}
        setIsOpen={setOpensuborderPopup}
        title={"Sub Orders"}
      >
        <div className={tw`w-[600px] `}>
          <Suborders id={rowid} />
        </div>
      </Modal>
    </>
  );
};

export default CreateCourierPickupRequest;

